import { Component, OnInit, ViewChild } from '@angular/core';
import { ArticulosService } from '../servicios/articulos.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PeticionesService } from '../servicios/httpservice';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject , Observable,Subscription } from 'rxjs';
import { map , first,takeUntil,takeWhile, delay,filter  } from 'rxjs/operators';
import { Router, NavigationStart, RouterEvent } from '@angular/router';
import { AlertifyService } from '../alertify.service';

 
@Component({
  selector: 'app-inventarios-ecodeli',
  templateUrl: './inventarios-ecodeli.component.html',
  styleUrls: ['./inventarios-ecodeli.component.css'],
})
export class InventariosEcodeliComponent implements OnInit {
  displayedColumns: string[] = ['sku', 'id','inventoryId', 'strDescripcion', 'dblInventario','invAnterior','actualizar'];
  public dataSource: any;
  public arrayArtsTiendaEco: any = [];
  public arrayArtsBDcomercial: any = [];
  public arrayArtsDetTiendaEco: any = [];
  public arrayRecorrerMasivo: any = [];
  public arrayMostrar: any[];
  public time:number=0;
  public spinerTab: boolean = false;
  public lastId: number = 0;
  public progress: number = 0;
  public intervalId: any;
  public duration: number = 60;
  public timeouts: any[] = [];
  public navigationSubscription: Subscription;
  public arrayArtsSubscription: Subscription;

  constructor(
    private _artServ: ArticulosService, private alert:AlertifyService,private _httpService: PeticionesService,    private _paginatorIntl: MatPaginatorIntl,    private router: Router  ) {
    this._paginatorIntl.itemsPerPageLabel = 'Artuculos por página';

    this._artServ.fnGetExistencias();
    /*this._artServ.arrayArts_$.subscribe((nuevoValor) => {
      if (nuevoValor && nuevoValor.length > 0) {
        this.arrayArtsBDcomercial = nuevoValor;
      
      } 
    });*/
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  textoBusqueda: string = '';
  ngAfterViewInit() {
    this.dataSource = new MatTableDataSource<PeriodicElement>(
      this.arrayMostrar
    );

       

  }

  ngOnInit(): void {

    this._artServ.arrayArts_$.pipe(  filter(nuevoValor => nuevoValor && nuevoValor.length > 0),
    first() ).subscribe((nuevoValor) => {
     console.log('regresa de servicio')
     console.log(nuevoValor);
   if(nuevoValor && nuevoValor.length > 0){
     this.arrayArtsBDcomercial = nuevoValor;
     this.fnextraerInventarioTE(this.lastId);
   
   }  
   }); 


    this.navigationSubscription = this.router.events.subscribe((event: RouterEvent) => { // Usa RouterEvent
      if (event instanceof NavigationStart){
        console.log("Navegación iniciada");
        clearInterval(this.intervalId);
        this.progress = 0;
        console.log("Navegación finalizada");
      }
    });
 
    //this.fnextraerInventarioTE(this.lastId);
   /*  this._artServ.fnGetExistencias();*/
    //llamar el servicio de articulos

  }

  ngOnDestroy(): void {

    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    this.detenerCargando();
    this.timeouts.forEach(timeout => clearTimeout(timeout));
  }

  detenerCargando() {
    clearInterval(this.intervalId); // Detener el intervalo
  }
  splitText(text: string): string {
    if (text.length > 50) { 
      const halfIndex = Math.ceil(text.length / 2);
      const firstHalf = text.substr(0, halfIndex);
      const secondHalf = text.substr(halfIndex);
      return `${firstHalf}<br>${secondHalf}`; 
    } else {
      return text;
    }
  }

  aplicarFiltro() {
    this.dataSource.filter = this.textoBusqueda.trim().toLowerCase();
  }

  limpiarFiltro() {
    this.textoBusqueda = '';
    this.aplicarFiltro();
  }

  fnextraerInventarioTE(id: number) {
    console.log('ingresa a fnextraerInventarioTE');
    this.spinerTab = true;
    let obj: any = {
      data: {},
      tipo: 'GET',
      api:
        'collections/431627010261/products.json?since_id=' + id + '&limit=250',
      /*   api:"collections/431627010261/products.json?since_id="+id+"" */
    };
    let completedCount = 0;
    this._httpService.getOrdersEcodeli(obj).subscribe(
      (data) => {
       // console.log(data.products);
          this.arrayArtsTiendaEco.push(...data.products);
        const ultimoId = data.products[data.products.length - 1]?.id;
       // console.log(ultimoId);
        /*  if (data.products.length > 0) { */
        if (ultimoId) {
          this.fnextraerInventarioTE(ultimoId);
        }else{
          if (this.arrayArtsTiendaEco && this.arrayArtsTiendaEco.length > 0) {
           // console.log(this.arrayArtsTiendaEco);
            let arrayIndefinidos = [],conta2=0;
            this.time=0
            this.arrayArtsTiendaEco.forEach((x) => {
              this.time = conta2 * 500;
             // console.log(this.time)
              conta2 ++;
              if(conta2 == this.arrayArtsTiendaEco.length){
                this.fnActivarCargando()
              }
              setTimeout(() => {
                // Aquí va el código que deseas ejecutar después de 2 segundos
                this.fnPorArticulo(x.id).subscribe((datos) => {
                  completedCount++;
                  if (completedCount === this.arrayArtsTiendaEco.length) {
                    console.log(this.arrayArtsDetTiendaEco);
                    console.log(arrayIndefinidos)
                    this.fnComparacion();
                  }
                });
              }, this.time);
            });
          } else {
            this.spinerTab = false;
          }
        }
      },
      (error) => {
        console.error('Error al obtener los articulos:', error);
        this.spinerTab = false;
      }
    );
  }

  fnPorArticulo(id: number): Observable<any> {
    let obj: any = {
      data: {},
      tipo: 'GET',
      api: 'products/' + id + '.json',
    };
    return this._httpService.getOrdersEcodeli(obj).pipe(
      map((data: any) => {
        this.arrayArtsDetTiendaEco.push(data.product);
        return data;
      })
    );
  }



  fnComparacion() {
    this.arrayMostrar = [];
    let arrayMulti = [],
      contador = 0;
    let artFind: any,objFind : {
        id: number;
        strDescripcion:string;
        dblInventario: number;
        exists: boolean;
        sku: string;
        inventoryId:number;
        invenAnterior:number;
      };

    this.arrayArtsDetTiendaEco.forEach((x) => {
      contador = 0;
      if (x && x.id) {
        if (arrayMulti.length == 0) {
          arrayMulti.push(x);
        } else {
          arrayMulti.forEach((o) => {
            if (x.id == o.id) {
              contador += 1;
            }
          });
          if (contador == 0) {
            arrayMulti.push(x);
          }
        }
      }
    });

    this.arrayArtsDetTiendaEco = arrayMulti;

    this.arrayArtsDetTiendaEco.forEach((o) => {

      if (o && o.variants && o.variants.length > 0 && o.variants[0].sku) {
        let skuart = o.variants[0].sku;
        artFind = this.arrayArtsBDcomercial.find((x) => x.strSKU == skuart);
      } else {
        artFind = undefined;
      }
      objFind = artFind ? {
            id: o.id,
            strDescripcion: o.title,
            sku: o.variants[0].sku,
            dblInventario: artFind.dblDisponible,
            exists: true,
            inventoryId:o.variants[0].inventory_item_id,
            invenAnterior:o.variants[0].old_inventory_quantity
          }:{
            id: o ? o.id : 0,
            strDescripcion: o ? o.title : '',
            sku: o ? o.variants[0].sku : '',
            dblInventario: 0,
            exists: false,
            inventoryId:o ? o.variants[0].inventory_item_id:0,
            invenAnterior:o.variants[0].old_inventory_quantity
          };
      this.arrayMostrar.push({
        id: objFind.id,
        sku: objFind.sku,
        dblInventario: objFind.dblInventario,
        strDescripcion: objFind.strDescripcion,
        existBD: objFind.exists,
        actualizar:"",
        inventoryId: objFind.inventoryId,
        invAnterior:objFind.invenAnterior
      });
    });
    // Actualizar dataSource
    this.dataSource = new MatTableDataSource<PeriodicElement>(
      this.arrayMostrar
    );
    this.dataSource.paginator = this.paginator;
    this.arrayRecorrerMasivo = this.arrayMostrar;
    this.spinerTab = false;
  }
  fnActivarCargando(){
    const intervalDuration = this.time / 100; // Convertir la duración a milisegundos y dividir en 100 partes
    this.intervalId = setInterval(() => {
      if (this.progress >= 99) {
        clearInterval(this.intervalId); // Detener el intervalo cuando el progreso llegue a 100
      }else if(this.progress == 2){
        this.spinerTab = false
      }
      this.progress = this.progress < 100 ? this.progress + 1 : 100;
    }, intervalDuration);
  }
  fnActInvSingular(x:any){
    console.log(x);
    if(x.existBD && (x.dblInventario + (x.invAnterior * -1))!= 0){
    let obj: any = {
      data: {
        "location_id":71453540565,
        "inventory_item_id":x.inventoryId,
        "available_adjustment":x.dblInventario + (x.invAnterior * -1)
      },
      tipo: 'POST',
      api:'inventory_levels/adjust.json',
    };
    console.log(obj)
    this._httpService.getOrdersEcodeli(obj).subscribe(
      (data) => {
        console.log(data)
        if (data.inventory_level){
          const datos =   this.arrayMostrar.slice();
          const indice = datos.findIndex(item => item.id === x.id);
          if (indice !== -1) {
            datos[indice].invAnterior = data.inventory_level.available;
            this.arrayMostrar = datos;
            this.dataSource = new MatTableDataSource<PeriodicElement>(
              this.arrayMostrar
            );
            this.dataSource.paginator = this.paginator;
            console.log(this.dataSource)
            this.alert.success("Se actualizo correctamente");
        } else {
            console.error(`No se encontró ningún objeto con el id ${x.id}`);
        }
        }else{
          this.alert.error("Error no devuelve nada");
        }
      },
      (error) => {
        console.error('Error al obtener los articulos:', error);
      }
    );}else{
      this.alert.message("El inventario no sufriría cambios.");
    }
  }

  fnActualizarMasivo(){
    let time=0;
    this.arrayRecorrerMasivo.forEach(ele => {
      if(ele.existBD && (ele.dblInventario + (ele.invAnterior * -1))!= 0){
        console.log(ele);
        const timeout = setTimeout(() => {
          this.fnActInvSingular(ele)
        }, time);
        this.timeouts.push(timeout);
        time +=2000; 
      }
    });
  }
}

export interface PeriodicElement {
  sku: string;
  id: number;
  dblInventario: number;
  strDescripcion: string;
  inventoryId:number;
  actualizar:string;
  invAnterior:number;
}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
